let dimensionTableHandlerBound = false;

export const dimensionTableHandler = () => {
  if (dimensionTableHandlerBound) return;
  dimensionTableHandlerBound = true;

  document.addEventListener("click", (event) => {
    const row = event.target.closest(".dti-row");
    if (!row) return;

    const dtiItem = row.closest(".dimenstion-table-item");
    const dtiImage = dtiItem?.querySelector(".dti-image");

    const isActive = dtiItem?.classList.contains("active");

    if (isActive) {
      dtiItem.classList.remove("active");
      dtiImage?.classList.remove("opened");
    } else {
      document
        .querySelectorAll(".dimenstion-table-item.active")
        .forEach((item) => {
          item.classList.remove("active");
          const openedImage = item.querySelector(".dti-image.opened");
          if (openedImage) {
            openedImage.classList.remove("opened");
          }
        });

      if (dtiItem) {
        dtiItem.classList.add("active");
      }

      if (dtiImage) {
        dtiImage.classList.add("opened");
        const rect = dtiImage.getBoundingClientRect();
        const isInView = rect.bottom <= window.innerHeight && rect.top >= 0;

        if (!isInView) {
          dtiImage.scrollIntoView({ behavior: "smooth", block: "end" });
        }
      }
    }
  });
};
